import { Attribute } from "../../types";

export const hasColumnId = (
  attribute: Attribute,
): attribute is Attribute & { columnId: string } => {
  return "columnId" in attribute;
};
